import ChallengeFind from './TournamentFind';
export default ChallengeFind;